import type {CustomVirtualizedSelection} from './types';

export const rowSelectionDefaults: Readonly<CustomVirtualizedSelection> = {
	all: false,
	includeIds: [],
	excludeIds: [],
};
